var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
var today  = new Date();

var monthNames = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند"];

export const dateTimeHumanReadable = (value) => {
    let date = value.toLocaleString().split(', ')[0].split('/');

    let dateText = date[1] + ' ' + monthNames[date[0]-1] + ' ' + date[2];

    return dateText;
};


export const dateOnlyReadable = (value) => {
    let [month, year, day] = value.toLocaleString().split(', ')[0].split('/');

    let dateText = `${day}/${month}/${year}`;

    return dateText;
};




// export const dateTimeOnlyReadable = (value) => {
//     let date = value.toLocaleString().split(', ')[0].split('/');

//     let dateText = date[2] + '/' + date[1] + '/' + date[0];

//     return value.toLocaleString().split(', ')[1] + ' ' + dateText;
// };


export const dateTimeOnlyReadable = (value) => {
    if (!value) return '';
    
    //let [year, day, month] = value.toLocaleString().split(', ')[0].split('/');
    let [month, year, day] = value.toLocaleString().split(', ')[0].split('/');

    let dateText = `${day}/${month}/${year}`;

    return `${value.toLocaleString().split(', ')[1]} ${dateText}`;
};